export enum RenewalStatus {
	Approved = "renew",
	Rejected = "demote"
}

export interface RenewRequest {
	message: string
}

export interface Props {
	onClose: () => void
	user: User
}

export interface User {
	imageId: string
	isDeleted: boolean
	name: string
	timeLeft: number
	userId: string
}